module.exports = __webpack_public_path__ + "images/help/video-preview-members-50701bb8d71d72c5d213ed1f12736999.png";